import React from "react";
import "../styles/homepage.css";
import { motion, useViewportScroll } from "framer-motion";
import { Link } from "react-router-dom";
import { useState } from "react";
// import Loader from "./Loader";
import "../styles/loader.css";
// import Contact from "./Contact";

const counterVariant = {
  rest: {
    scale: 1,
  },
  hover: {
    scale: 1.1,
    transition: {
      type: "spring",
      stiffness: 100,
      duration: 0.3,
    },
  },
};

// const slideInVariant = {
//   rest: {
//     opacity: 0,
//   },
//   after: {
//     opacity: 1,
//   },
// };
const InsideHome = () => {
  const [x, setX] = useState(0);
  // const contentCount = 4;
  const factor = 1 / 4;
  const { scrollYProgress } = useViewportScroll();
  scrollYProgress.onChange((value) => {
    setX(value);
    // console.log(x);
  });
  return (
    <motion.div>
      {/* =========================counter stars here======================================= */}
      <motion.div className="home-content  counter-container text-gray-700 body-font my-1 flex flex-col items-center justify-center">
        {/* <motion.div className="container px-5 py-14 mx-auto"> */}
        <motion.div
          className="flex flex-wrap -m-4 text-center w-full"
          //   variants={slideInVariant}
        >
          <motion.div
            className="p-4 lg:w-1/4 sm:w-1/2 w-full"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial={{
              opacity: 0,
              x: -1000,
            }}
            animate={{
              x: x >= (2 * factor) / 2 ? 0 : -1000,
              opacity: 1,
            }}
            transition={{ stiffness: 50, duration: 0.5, type: "spring" }}
          >
            <motion.div className="counter border-2 border-blue-500 px-5 py-6 rounded-full ">
              <svg
                fill="none"
                stroke="gray"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="text-indigo-500 w-12 h-12 mb-3 inline-block"
                viewBox="0 0 24 24"
              >
                <path d="M8 17l4 4 4-4m-4-5v9"></path>
                <path d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"></path>
              </svg>
              <h2 className="title-font font-medium text-3xl text-gray-900  dark:text-gray-300">
                1000+
              </h2>
              <p className="leading-relaxed text-gray-700  dark:text-gray-300 text-lg lg:text-xl font-semibold">
                Registrations
              </p>
            </motion.div>
          </motion.div>
          <motion.div
            className="p-4 lg:w-1/4 sm:w-1/2 w-full"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial={{
              opacity: 0,
              x: -1000,
            }}
            animate={{
              x: x >= (2 * factor) / 2 ? 0 : -1000,
              opacity: 1,
            }}
            transition={{ stiffness: 50, duration: 0.5, type: "spring" }}
          >
            <div className="counter border-2 border-yellow-500 px-5 py-6 rounded-full ">
              <svg
                fill="none"
                stroke="gray"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="text-indigo-500 w-12 h-12 mb-3 inline-block"
                viewBox="0 0 24 24"
              >
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 00-3-3.87m-4-12a4 4 0 010 7.75"></path>
              </svg>
              <h2 className="title-font font-medium text-3xl text-gray-900  dark:text-gray-300">
                30+
              </h2>
              <p className="leading-relaxed text-gray-700 text-lg lg:text-xl font-semibold  dark:text-gray-300">
                Developers
              </p>
            </div>
          </motion.div>
          <motion.div
            className="p-4 lg:w-1/4 sm:w-1/2 w-full"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial={{
              opacity: 0,
              x: 1000,
            }}
            animate={{
              x: x >= (2 * factor) / 2 ? 0 : 1000,
              opacity: 1,
            }}
            transition={{ stiffness: 50, duration: 0.5, type: "spring" }}
          >
            <div className="counter border-2 border-red-500 px-5 py-6 rounded-full ">
              <svg
                fill="none"
                stroke="gray"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="text-indigo-500 w-12 h-12 mb-3 inline-block"
                viewBox="0 0 24 24"
              >
                <path d="M3 18v-6a9 9 0 0118 0v6"></path>
                <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"></path>
              </svg>
              <h2 className="title-font font-medium text-3xl text-gray-900  dark:text-gray-300">
                100+
              </h2>
              <p className="leading-relaxed text-gray-700 text-lg lg:text-xl font-semibold  dark:text-gray-300">
                Connections
              </p>
            </div>
          </motion.div>
          <motion.div
            className="p-4 lg:w-1/4 sm:w-1/2 w-full"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={counterVariant}
            initial={{
              opacity: 0,
              x: 1000,
            }}
            animate={{
              x: x >= (2 * factor) / 2 ? 0 : 1000,
              opacity: 1,
            }}
            transition={{ stiffness: 50, duration: 0.5, type: "spring" }}
          >
            <div className="counter border-2 border-green-500 px-5 py-6 rounded-full">
              <svg
                fill="none"
                stroke="gray"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="text-indigo-500 w-12 h-12 mb-3 inline-block"
                viewBox="0 0 24 24"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              <h2 className="title-font font-medium text-3xl text-gray-900  dark:text-gray-300">
                40+
              </h2>
              <p className="leading-relaxed text-gray-700 text-lg lg:text-xl font-semibold  dark:text-gray-300">
                Projects
              </p>
            </div>
          </motion.div>
        </motion.div>
        {/* </motion.div> */}
      </motion.div>
      {/* ============================counter ends here================================= */}

      {/* ================events=================== */}

      <motion.div className="home-content  h-full flex flex-col items-center justify-center my-1">
        <motion.div>
          <motion.div className="row">
            <motion.div
              className="column flex flex-col justify-center "
              initial={{
                opacity: 0,
                x: -1000,
              }}
              animate={{
                x: x >= (3 * factor) / 2 ? 0 : -1000,
                opacity: 1,
              }}
              transition={{ stiffness: 80, duration: 0.5, type: "spring" }}
            >
              <motion.div className="img1"></motion.div>
            </motion.div>
            <motion.div
              className="column flex flex-col items-center justify-center "
              initial={{
                opacity: 0,
                x: 1000,
              }}
              animate={{
                x: x >= (3 * factor) / 2 + factor / 4 ? 0 : 1000,
                opacity: 1,
              }}
              transition={{ stiffness: 60, duration: 0.5, type: "spring" }}
            >
              <motion.div className=" text-5xl w-full font-semibold text-gray-700 dark:text-gray-200">
                Events
              </motion.div>
              <p className="my-4 text-gray-600 text-lg dark:text-gray-300">
                Do you ever struggle to think new ideas or want to know the
                exact need of today and current market statergies?
                <br></br>
                Here we are eager to help you!
                <br></br>
                We organise various events related to various domains. Along
                with hands on sessions, roadmaps, quizzes and many more.
              </p>

              {/* <a href="" className="btn">Tap</a> */}
              {/* <NavLink exact to="/events" activeClassName="navbar-active" className="btn">
                Tap
            </NavLink> */}
              <motion.div className="w-full">
                <motion.button
                  className="timeline-button
                py-1
                px-7
                mt-2
                text-base
                font-medium
                cursor-pointer
                dark:text-white
                text-align:center
                "
                  whileHover={{
                    scale: 1.3,
                    boxShadow: "-3px 3px 8px rgba(218,57,159,0.3)",
                  }}
                  transition={{ type: "spring", stiffness: 500 }}
                >
                  <Link
                    to="/events"
                    className="
                    no-underline
                    text-lg
                    font-bold
                    text-gray-700
                    dark:text-gray-300
                  "
                  >
                    Join Events
                  </Link>
                </motion.button>
              </motion.div>
              {/* <span className="tap">To Join Events..</span> */}
            </motion.div>
          </motion.div>
          <br></br>
          <br></br>
        </motion.div>
      </motion.div>

      {/* ==================team======================= */}
      <motion.div className=" home-content h-full flex flex-col items-center justify-center my-1">
        <motion.div>
          <motion.div className="row flex flex-col-reverse md:flex-row ">
            <motion.div
              className="column flex flex-col items-center justify-center"
              initial={{
                opacity: 0,
                x: -1000,
              }}
              animate={{
                x: x >= (4 * factor) / 2 + factor / 2 ? 0 : -1000,
                opacity: 1,
              }}
              transition={{ stiffness: 60, duration: 0.5, type: "spring" }}
            >
              <motion.div className="font-semibold text-gray-700 dark:text-gray-200 text-5xl mb-3 w-full">
                Team
              </motion.div>
              <p className="my-4 text-gray-600 dark:text-gray-300 text-lg">
                We're a team of Exploreres, Designers, Developers having
                creative, technical and strategic talents.
                <br></br>
                Meet our team of digital warriors, ready to harness the force
                for good.. we are the people who make magic happen..
                <br></br>
                We approach work and play with curiosity and experimentation, to
                create meaningful projects that connect with people, just like
                you..
              </p>
              <br></br>
              <motion.div className="w-full">
                <motion.button
                  className="timeline-button
                py-1
                px-7
                text-base
                font-medium
                cursor-pointer
                dark:text-white
                "
                  whileHover={{
                    scale: 1.3,
                    boxShadow: "-3px 3px 8px rgba(218,57,159,0.3)",
                  }}
                  transition={{ type: "spring", stiffness: 500 }}
                >
                  <Link
                    to="/team"
                    className="
                    no-underline
                    text-lg
                    font-bold
                    text-gray-700
                    dark:text-gray-300
                  "
                  >
                    Meet our Team
                  </Link>
                </motion.button>
              </motion.div>
              {/* <span className="tap">To Meet our Team..</span> */}
              {/* <a href="" className="btn">Tap</a>to Meet our team.. */}
            </motion.div>
            <motion.div
              className="column "
              initial={{
                opacity: 0,
                x: 1000,
              }}
              animate={{
                x: x >= (4 * factor) / 2 ? 0 : 1000,
                opacity: 1,
              }}
              transition={{ stiffness: 80, duration: 0.5, type: "spring" }}
            >
              <motion.div className="img2"></motion.div>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* ================================projects==================== */}

      {/* <motion.div className=" home-content h-full flex flex-col items-center justify-center my-1">
        <motion.div>
          <motion.div className="row ">
            <motion.div
              className="column flex flex-col justify-between"
              initial={{
                opacity: 0,
                x: -1000,
              }}
              animate={{
                x: x >= (5 * factor) / 2 + factor / 4 ? 0 : -1000,
                opacity: 1,
              }}
              transition={{ stiffness: 80, duration: 0.5, type: "spring" }}
            >
              <motion.div className="img3"></motion.div>
            </motion.div>
            <motion.div
              className="column flex flex-col items-center justify-center "
              initial={{
                opacity: 0,
                x: 1000,
              }}
              animate={{
                x: x >= (5 * factor) / 2 + factor / 2 ? 0 : 1000,
                opacity: 1,
              }}
              transition={{ stiffness: 60, duration: 0.5, type: "spring" }}
            >
              <motion.div className="font-semibold text-gray-700 dark:text-gray-200 text-5xl mb-3 w-full">
                Projects
              </motion.div>

              <p className="my-4 text-gray-600 dark:text-gray-300 text-lg">
                Plans are only good intentions unless they immediately
                degenerate into hard work.
                <br></br>
                Here we are working on some ideas that will solve real life
                problems. We are happy to invite you to Collaborate with us.
                <br></br>
                We believe that Team work makes the dream work..
              </p>
              <br></br>
              <motion.div className="w-full">
                <motion.button
                  className="timeline-button
                py-1
                px-7
                text-base
                font-medium
                cursor-pointer
                dark:text-white
                "
                  whileHover={{
                    scale: 1.3,
                    boxShadow: "-3px 3px 8px rgba(218,57,159,0.3)",
                  }}
                  transition={{ type: "spring", stiffness: 500 }}
                >
                  <Link
                    to="/projects"
                    className="
                    no-underline
                    text-lg
                    font-bold                    
                    text-gray-700
                    dark:text-gray-300
                  "
                  >
                    Collaborate
                  </Link>
                </motion.button>
              </motion.div>

              <br></br>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div> */}

      {/* ==============================contact usstarts here================== */}
    </motion.div>
  );
};

export default InsideHome;
